import {SidebarPageLayout, useSidebarPageLayoutActions} from '@github-ui/layout-primitives/SidebarPageLayout'
import {useLocation} from '@github-ui/react-router'
import {useEffect} from 'react'

/**
 * The stacks pages have their own headings and no search, so on narrow screens their header is only the trigger for
 * the dashboard sidebar.
 */
export function RepoStacksHeader({showSidebar}: {showSidebar: boolean}) {
  const {closeDialog} = useSidebarPageLayoutActions()
  const {key} = useLocation()

  // The dashboard layout owns the sidebar dialog and stays mounted across its pages, and its links don't close the
  // dialog. Close it when the reader navigates away, so it doesn't stay open over the next page.
  useEffect(() => closeDialog, [key, closeDialog])

  if (!showSidebar) return null

  return (
    <div className="hide-lg hide-xl mb-3">
      <SidebarPageLayout.SidebarTrigger />
    </div>
  )
}
